import { responseLookupServiceTypes } from './types'
import * as lookupServiceURL from './lookupServiceURL'
import useCallApi from '../../utilities/axios'

const useLookupService = () => {
    const callApi = useCallApi()
    const example1 = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: lookupServiceURL.example,
        })
        return data
    }
    const example2 = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: lookupServiceURL.example,
        })
        return data
    }

    const callProjectTypeLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ProjectTypeLutType>({
            url: lookupServiceURL.projectTypeLutUrl,
        })
        return data
    }

    const callFacultyLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.FacultyLutType>({
            url: lookupServiceURL.facultyLutUrl,
        })
        return data
    }

    const callProjectSubmitTypeLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ProjectSubmitTypeLutType>({
            url: lookupServiceURL.projectSubmitTypeLutUrl,
        })
        return data
    }

    const callResearcherTypeLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ResearcherLutType>({
            url: lookupServiceURL.researcherTypeLutUrl,
        })
        return data
    }

    const callTitleNameLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.TitleNameLutType>({
            url: lookupServiceURL.titleNameLutUrl,
        })
        return data
    }

    const callAcademicPositionLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.AcademicPositionLutType>({
            url: lookupServiceURL.academicPositionLutUrl,
        })
        return data
    }

    const callDocumentTopicLut = async (irbID: number, submitTypeID?: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.DocumentTopicLutType>({
            url: `${lookupServiceURL.documentTopicLutUrl}/${irbID}/${submitTypeID ? submitTypeID : ''}`,
        })
        return data
    }

    const callPublicDocumentTopicLut = async (irbID: number, submitTypeID?: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.DocumentTopicLutType>({
            url: `${lookupServiceURL.publicDocumentTopicLutUrl}/${irbID}/${submitTypeID ? submitTypeID : ''}`,
        })
        return data
    }

    const callDocumentTopicCloseLut = async (irbID: number, submittedTypeID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.DocumentTopicLutType>({
            url: `${lookupServiceURL.documentTopicLutUrl}/${irbID}/${submittedTypeID}`,
        })
        return data
    }

    const callDirectorNameLut = async (irb: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.DirectorNameLutType>({
            url: `${lookupServiceURL.directorNameUrl}/${irb}`,
        })
        return data
    }

    const callRoleLut = async (irbID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.RoleLutType>({
            url: `${lookupServiceURL.roleUrl}/${irbID}`,
        })
        return data
    }

    const callStatusLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.StatusLutType>({
            url: lookupServiceURL.statusUrl,
        })

        return data
    }

    const callSubmittedStatusLut = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.StatusLutType>({
            url: lookupServiceURL.submittedStatusUrl,
        })

        return data
    }

    const callReviewerLut = async (irbID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ReviewerLutType>({
            url: `${lookupServiceURL.reviewerUrl}/${irbID}`,
        })

        return data
    }

    const callApproveStatusLut = async (irbID: number, submitTypeID?: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ReviewerLutType>({
            url: `${lookupServiceURL.approveStatusUrl}/${irbID}/${submitTypeID ? submitTypeID : ''}`,
        })
        return data
    }
    type ApproveStatusSubmitType = { irbID: number; submitType: number }
    const callApproveStatusLutSubmitType = async ({ irbID, submitType }: ApproveStatusSubmitType) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ReviewerLutType>({
            url: `${lookupServiceURL.approveStatusUrl}/${irbID}/${submitType}`,
        })
        return data
    }

    const callApproveStatusLutProjectRenewal = async (irbID: number, isCommittee: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ReviewerLutType>({
            url: `${lookupServiceURL.approveStatusProjectRenewal}/${irbID}/${isCommittee}`,
        })

        return data
    }

    const callCommentaryTopicLut = async (irbID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.CommentaryTopicLutType>({
            url: `${lookupServiceURL.commentaryTopicUrl}/${irbID}`,
        })

        return data
    }

    const callCommitteeLut = async (submittedID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.CommitteeLutType>({
            url: `${lookupServiceURL.committee}/${submittedID}`,
        })

        return data
    }

    const getEducationLevel = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.EducationLevelType>({
            url: `${lookupServiceURL.educationLevelUrl}`,
        })

        return data
    }

    const getTerminateCause = async (irb: number, submitType: Number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.TerminateLutType>({
            url: `${lookupServiceURL.terminateCause}/${irb}/${submitType}`,
        })

        return data
    }

    const getRequestConsiderDoc = async (userGroupID: number, projectID: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.RequestConsiderDocType>({
            url: `${lookupServiceURL.requestConsiderDocUrl}/${userGroupID}/${projectID}`,
        })
        return data
    }

    const getApproveStatusByCloseProject = async (irb: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ApproveStatusByCloseProjectType>({
            url: `${lookupServiceURL.approveStatusByCloseProject}/${irb}`,
        })
        return data
    }

    const getExpertiseFaculty = async () => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.ExpertiseFaculty>({
            url: `${lookupServiceURL.expertiseFaculty}`,
        })
        return data
    }

    return {
        example1,
        example2,
        callProjectTypeLut,
        callFacultyLut,
        callProjectSubmitTypeLut,
        callResearcherTypeLut,
        callTitleNameLut,
        callAcademicPositionLut,
        callDocumentTopicLut,
        callPublicDocumentTopicLut,
        callDirectorNameLut,
        callRoleLut,
        callStatusLut,
        callReviewerLut,
        callApproveStatusLut,
        callCommentaryTopicLut,
        callDocumentTopicCloseLut,
        callCommitteeLut,
        getEducationLevel,
        callApproveStatusLutProjectRenewal,
        getTerminateCause,
        callApproveStatusLutSubmitType,
        getRequestConsiderDoc,
        getApproveStatusByCloseProject,
        callSubmittedStatusLut,
        getExpertiseFaculty,
    }
}

export default useLookupService
